import { render } from "./Keypoint.vue?vue&type=template&id=433e6c3c&scoped=true"
import script from "./Keypoint.vue?vue&type=script&lang=js"
export * from "./Keypoint.vue?vue&type=script&lang=js"

import "./Keypoint.vue?vue&type=style&index=0&id=433e6c3c&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433e6c3c"]])

export default __exports__